import { strings } from '@/i18n/i18n';
/*
 * @Author: shiguang
 * @Date: 2023-04-26 10:22:04
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-13 14:01:18
 * @Description: 56
 */

export enum ENUM_PICK_MAP_TYPE {
    /** 选择 map 中部分 key 映射到 options */
    PICK = 1,
    /** 剔除 map 中部分 key 映射到 options */
    OMIT = 2,
    /** 所有 map 中 key 映射到 options */
    ALL = 3
}

export enum PROMOTYPE {
    PRO = 'PRO',
    PURE = 'PURE'
}

export enum PROMOSTATUS {
    /** 待审核 */
    AUDITING = 'AUDITING',
    /** 成功 */
    SU = 'SU',
    /** 失败 */
    FAIL = 'FAIL',
    /** 待审查 */
    RULE_REVIEW = 'RULE_REVIEW'
}

export {};

// 当前会员等级
export enum MEMBERLEVEL {
    /** 经济舱 */
    LEVEL1 = 'LEVEL1',
    /** 标准舱 */
    LEVEL2 = 'LEVEL2',
    /** 商务舱 */
    LEVEL3 = 'LEVEL3',
    /** 头等舱 */
    SUPER = 'SUPER',
    /** 特殊会员 */
    SPECIAL = 'SPECIAL'
}

// 奖励发放状态
export enum PAYPLANSTATUS {
    /** 待发放 */
    UNPAID = 'UNPAID',
    /** 已发放 */
    ALL = 'ALL',
    /** 已取消 */
    CANCEL = 'CANCEL'
}

// 明细
export enum DETAILTYPE {
    /** 会员奖励 */
    MEMBER = 'MEMBER',
    /** 订单奖励 */
    ORDER = 'ORDER',
    /** 钱包转出 */
    TR_OUT = 'TR_OUT'
}

// 费用类型
export enum FEETYPE {
    /** 推广联盟返佣 */
    COMMISSION = 'COMMISSION',
    /** 振替（出金) */
    OUT = 'OUT'
}

/** 奖励tab类型 */
export enum REWARDTABTYPE {
    // 订单
    ORDER = 'order',
    // 会员
    MEMBER = 'member'
}

// 奖励金额取值
export enum REWARDAMOUNTRANGE {
    // 会员
    MEMBER = 'MEMBER',
    // 订单
    ORDER = 'ORDER',
    // 会员订单奖励之和
    MEMBER_AND_ORDER = 'MEMBER_AND_ORDER',
    // 会员订单奖励最大
    MAX_MEMBER_ORDER = 'MAX_MEMBER_ORDER'
}

/** 计费方式 */
export enum COSTTYPE {
    FEE_RATE = 'FEE_RATE',
    FIXED_AMOUNT = 'FIXED_AMOUNT',
    ONE_MONTH_FEE_RATE = 'ONE_MONTH_FEE_RATE'
}

// 分期类型  phaseType
export enum PHASETYPE {
    // 每月
    MONTH_1 = 'MONTH_1',
    // 每季
    MONTH_3 = 'MONTH_3',
    // 每半年
    MONTH_6 = 'MONTH_6'
}

export const TIMEUNIT = {
    DAY: strings.t('天'),
    MONTH: strings.t('月')
};

/**
 * 国家及货币单位
 */
export enum Site {
    /**
     * 日本站
     */
    JP = 'JapanStation',
    /**
     * 韩国站
     */
    KR = 'KoreaStation',
    /**
     * 英国站
     */
    UK = 'UkStation'
}

/**
 * 站点对应的货币单位
 */
export const siteMapMonetaryUnit = (() => {
    const siteMapMonetaryUnit = new Map<string, string>();
    siteMapMonetaryUnit.set(Site.JP, strings.t('円'));
    siteMapMonetaryUnit.set(Site.KR, '₩');
    siteMapMonetaryUnit.set(Site.UK, '$');
    return siteMapMonetaryUnit;
})();
// 国家货币
export const countryCurrency = new Map<string, string>();
countryCurrency.set(Site.JP, 'JPY');
countryCurrency.set(Site.KR, 'KRW');
countryCurrency.set(Site.UK, 'USD');

/**
 * 国家枚举
 */
export enum CountriesEnum {
    /**
     * 日本
     */
    Japan = 'JP',
    /**
     * 澳大利亚
     */
    Australia = 'AU',
    /**
     * 加拿大
     */
    Canada = 'CA',
    /**
     * 爱尔兰
     */
    Ireland = 'IE',

    /**
     * 韩国
     */
    Korea = 'KR',
    /**
     * 马来西亚
     */
    Malaysia = 'MY',
    /**
     * 新西兰
     */
    NewZealand = 'NZ',
    /**
     * 新加坡
     */
    Singapore = 'SG',
    /**
     * 英国
     */
    UK = 'GB',
    /**
     * 其他国家
     */
    other = 'OTHER'
}

/**
 * 国家枚举
 */
export const CountriesDescEnum = {
    /**
     * 日本
     */
    JP: strings.t('日本'),
    /**
     * 澳大利亚
     */
    AU: strings.t('澳大利亚'),
    /**
     * 加拿大
     */
    CA: strings.t('加拿大'),
    /**
     * 爱尔兰
     */
    IE: strings.t('爱尔兰'),

    /**
     * 韩国
     */
    KR: strings.t('韩国'),
    /**
     * 马来西亚
     */
    MY: strings.t('马来西亚'),
    /**
     * 新西兰
     */
    NZ: strings.t('新西兰'),
    /**
     * 新加坡
     */
    SG: strings.t('新加坡'),
    /**
     * 英国
     */
    GB: strings.t('英国'),
    /**
     * 其他国家
     */
    OTHER: strings.t('其他国家')
};
